export default "__VITE_ASSET__CAHqUe$a__"